<template>
  <div class="data-manage">
    <a-row :gutter="20">
      <a-col :span="7">
        <div class="leftSite">
          <div>
            <a-input-search
              placeholder="请输入用户组名称进行查询"
              style="width: 100%"
              class="inputSearch"
              @search="onSearch"
              allow-clear
            />
            <div
              style="
                display: flex;
                margin-top: 26px;
                justify-content: space-between;
                margin-bottom: 30px;
              "
            >
              <a-button
                type="primary"
                style="width: 30%; height: 32px; background: #1890ff; border-radius: 2px"
                @click="showModalC"
                icon="plus"
                >新增</a-button
              >
              <a-button
                type="primary"
                style="width: 30%; height: 32px; background: #1890ff; border-radius: 2px"
                @click="editItem"
                icon="edit"
                >编辑</a-button
              >
              <a-popconfirm title="确定要删除吗?" @confirm="() => deleteGroup()">
                <a-button
                  type="primary"
                  icon="delete"
                  style="width: 30%; height: 32px; background: #1890ff; border-radius: 2px"
                  >删除</a-button
                >
              </a-popconfirm>
            </div>
          </div>
          <div style="overflow: auto; height: 76vh; margin-right: -20px">
            <div v-for="(item, index) in dataGroup" :key="index" style="margin-right: 20px">
              <div
                :class="item.check ? 'buttonGroupCheck' : 'buttonGroup'"
                @click="checkButton(index)"
              >
                {{ item.groupName }}
              </div>
            </div>
          </div>
        </div>
        <!-- <star-condition-layout
          :onSearch="handleSearch"
          :onReset="reset"
          :loading="loading"
          ref="condition"
        >
          <star-condition-cell label="用户名">
            <a-input v-model="search.userName" placeholder="请输入关键字" />
          </star-condition-cell>
          <star-condition-cell label="手机号">
            <a-input v-model="search.phone" placeholder="请输入手机号" />
          </star-condition-cell>
          <star-condition-cell label="邮箱">
            <a-input v-model="search.mail" placeholder="请输入邮箱" />
          </star-condition-cell>
        </star-condition-layout> -->
      </a-col>
      <a-col :span="17">
        <div class="table-wrap">
          <TableHeadIcons :onRefresh="getTableList" :size.sync="tableDensity" :columns="columns">
            <a-button type="primary" @click="handleAdd">添加用户组成员</a-button>
          </TableHeadIcons>

          <a-table
            :loading="loadings"
            :size="tableDensity"
            :pagination="pagination"
            rowKey="userId"
            :columns="showColumns"
            :dataSource="dataSource"
          >
            <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
            <span slot="userDto.status" slot-scope="text, record">
              <div style="display: flex" v-if="record.userDto.status == '-1'">
                <div
                  style="
                    width: 6px;
                    height: 6px;
                    background: #d8d8d8;
                    border-radius: 50%;
                    margin-top: 8px;
                    margin-right: 3px;
                  "
                ></div>
                <div>停用</div>
              </div>
              <div style="display: flex" v-else>
                <div
                  style="
                    width: 6px;
                    height: 6px;
                    background: #22f525;
                    border-radius: 50%;
                    margin-top: 8px;
                    margin-right: 3px;
                  "
                ></div>
                <div>使用中</div>
              </div>
            </span>
            <span slot="createTime" slot-scope="text, record">{{
              record.createTime | formateTime
            }}</span>
            <div slot="action" slot-scope="text, record">
              <a-popconfirm title="确定要移除吗?" @confirm="() => handleDelete(record)">
                <a href="javascript:;">移除</a>
              </a-popconfirm>
            </div>
          </a-table>
        </div>
      </a-col>
    </a-row>
    <a-drawer
      :title="formModel == null ? '新增用户' : '修改用户'"
      width="600"
      :closable="true"
      :visible="visible"
      @close="visible = false"
    >
      <Form ref="form" v-if="visible" @refresh="handleRefresh" :formModel="formModel" />
    </a-drawer>
    <a-modal
      title="添加用户组成员"
      :visible="visibleM"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      centered
    >
      <div>添加用户组成员</div>
      <a-select
        mode="multiple"
        style="width: 100%; margin-top: 10px"
        placeholder="支持搜索和选择多个"
        v-model="people"
        :filter-option="filterOption"
      >
        <a-select-option v-for="(item, index) in dataPeople" :key="index" :value="item.userId">
          {{ item.userName }}
        </a-select-option>
      </a-select>
    </a-modal>

    <a-modal
      title="新增用户组"
      :visible="visibleC"
      :confirm-loading="confirmLoadingC"
      @ok="handleOkC"
      @cancel="handleCancelC"
      centered
    >
      <a-form-model :layout="layout" :model="form" :rules="rules" ref="form1">
        <a-form-model-item label="用户组名称" prop="groupName">
          <a-input v-model="form.groupName" placeholder="请输入用户名称" />
        </a-form-model-item>
        <a-form-model-item label="角色类型" prop="roleId">
          <a-select
            v-model="form.roleId"
            style="width: 100%; margin-top: 10px"
            placeholder="请选择角色类型"
          >
            <a-select-option
              v-for="(item, index) in dataRole"
              :key="index"
              :value="item.userRoleId"
            >
              {{ item.userRoleName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="添加用户组成员" prop="people">
          <a-select
            v-model="form.people"
            mode="multiple"
            style="width: 100%; margin-top: 10px"
            placeholder="支持搜索和选择多个"
            @change="handleChange"
            :filter-option="filterOption"
          >
            <a-select-option v-for="(item, index) in dataPeople" :key="index" :value="item.userId">
              {{ item.userName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  queryUserApi,
  deleteUserApi,
  info,
  detailId,
  detail,
  detailDelete,
  detailEdit,
  notAllot,
  detailMember,
  detailMemberDelete
} from '@/api/System/User'
import { queryRoleApi } from '@/api/System/Role'
// import moment from 'moment'
import Form from './Form.vue'
export default {
  data() {
    return {
      tableDensity: 'middle',
      loadings: false,
      visible: false,
      visibleM: false,
      confirmLoading: false,
      visibleC: false,
      confirmLoadingC: false,
      layout: 'horizontal',
      people: [],
      form: {
        groupName: undefined,
        roleId: undefined,
        people: undefined
      },
      dataPeople: [],
      rules: {
        groupName: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        roleId: [{ required: true, message: '请输入角色类型', trigger: 'blur' }]
        // people: [{ required: true, message: '请选择用户组成员', trigger: 'blur' }]
      },
      search: {
        userName: undefined,
        phone: undefined,
        mail: undefined,
        needUserRole: true
      },
      columns: [
        {
          width: 60,
          align: 'center',
          title: '序号',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '用户名',
          ellipsis: true,
          show: true,
          dataIndex: 'userDto.userName'
        },
        {
          title: '手机号',
          ellipsis: true,
          show: true,
          dataIndex: 'userDto.phone',
          width: 200
        },
        {
          title: '邮箱',
          ellipsis: true,
          show: true,
          dataIndex: 'userDto.mail'
        },
        {
          title: '角色类型',
          ellipsis: true,
          show: true,
          dataIndex: 'role'
        },
        {
          title: '用户状态',
          show: true,
          scopedSlots: { customRender: 'userDto.status' },
          width: 130
        },
        {
          title: '创建时间',
          ellipsis: true,
          show: true,
          dataIndex: 'userDto.createTime'
        },
        {
          title: '操作',
          width: 60,
          show: true,
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      dataRole: [],
      pagination: {
        size: 'default'
      },
      index: 0,
      dataGroup: [],
      dataGroupCopy: [],
      checkItem: {},
      sorter: {},
      formModel: null
    }
  },
  created() {
    // this.getTableList()
    this.getRoleList()
    this.leftData()
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onSearch(value) {
      this.dataGroup = this.dataGroupCopy.filter((array) => array.groupName.match(value))
      this.dataGroup.forEach((element) => {
        element.check = false
      })
      this.checkItem = this.dataGroup[0]
      this.checkItem.check = true
      this.dataSource = this.checkItem.userGroupMemberDtoList
    },
    deleteGroup() {
      if (this.checkItem) {
        detailDelete(this.checkItem.id).then((res) => {
          if (res.code === 200) {
            this.$message.success(res.msg)
            setTimeout(() => {
              this.leftData()
            }, 400)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请先添加用户组')
      }
    },
    async editItem() {
      if (this.checkItem) {
        let query = {
          pn: 1,
          pageSize: 99999999
        }
        this.loading = true
        let res = await notAllot(query)
        let { code, msg, data, extra } = res
        if (code == '200') {
          this.dataPeople = [...data]
          if (this.checkItem.userGroupMemberDtoList) {
            this.checkItem.userGroupMemberDtoList.forEach((element) => {
              this.dataPeople.push({
                userId: element.userDto.userId,
                userName: element.userDto.userName
              })
            })
          }
        } else {
          this.$message.error(msg)
        }
        this.clearForm()
        this.form.groupName = this.checkItem.groupName
        this.form.roleId = this.checkItem.userRoleDto.userRoleId
        let ids = []
        if (this.checkItem.userGroupMemberDtoList) {
          this.checkItem.userGroupMemberDtoList.forEach((element) => {
            ids.push(element.userId)
          })
        }

        this.form.people = ids
        this.form.id = this.checkItem.id
        setTimeout(() => {
          this.visibleC = true
        }, 400)
      } else {
        this.$message.error('请先添加用户组')
      }
    },
    leftData() {
      this.loadings = true
      info().then((res) => {
        this.loadings = false
        if (res.data.length > 0) {
          res.data.forEach((element) => {
            element.check = false
          })
          this.checkItem = res.data[0]
          res.data[0].check = true
          this.dataGroup = res.data
          this.dataGroupCopy = res.data
          if (res.data[0].userGroupMemberDtoList) {
            res.data[0].userGroupMemberDtoList.forEach((element) => {
              element.role = res.data[0].userRoleDto.userRoleName
              element.userName = element.userDto.userName
            })
            this.dataSource = res.data[0].userGroupMemberDtoList
          } else {
            this.dataSource = []
          }
        } else {
          this.checkItem = {}
          this.dataGroup = []
          this.dataGroupCopy = []
          this.dataSource = []
        }
      })
    },
    async showModal() {
      await this.getTableList()
      this.visibleM = true
    },
    async showModalC() {
      this.clearForm()
      await this.getTableList()
      this.visibleC = true
    },
    handleOk(e) {
      this.confirmLoading = true
      if (this.people.length > 0) {
        let param = { userIdList: this.people, groupId: this.checkItem.id }
        detailMember(param).then((res) => {
          if (res.code === 200) {
            this.leftData()
            this.$message.success(res.msg)
            this.visibleM = false
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.info('请选择要添加的用户组成员')
      }

      this.confirmLoading = false
    },
    handleCancel(e) {
      this.visibleM = false
    },
    handleOkC(e) {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.confirmLoadingC = true
          let param = { ...this.form }
          if (param.people) {
            if (param.people.length > 0) {
              let a = []
              param.people.forEach((element) => {
                a.push({ userId: element })
              })
              param.userGroupMemberDtoList = a
            } else {
              param.userGroupMemberDtoList = []
            }
          } else {
            param.userGroupMemberDtoList = []
          }
          delete param.people
          if (param.id) {
            detailEdit(param).then((res) => {
              this.confirmLoadingC = false
              if (res.code === 200) {
                this.$message.success(res.msg)
                this.visibleC = false

                this.leftData()
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            detail(param).then((res) => {
              this.confirmLoadingC = false
              if (res.code === 200) {
                this.$message.success(res.msg)
                this.visibleC = false

                this.leftData()
              } else {
                this.$message.error(res.msg)
              }
            })
          }
          // setTimeout(() => {
          //   this.visibleC = false
          //   this.confirmLoadingC = false
          // }, 2000)
        }
      })
    },
    clearForm() {
      this.form = {
        groupName: undefined,
        roleId: undefined,
        people: undefined
      }
    },
    handleCancelC(e) {
      this.visibleC = false
    },
    handleChange(value) {
    },
    reset() {
      this.search.userName = undefined
      this.search.phone = undefined
      this.search.mail = undefined
      this.getTableList()
    },
    checkButton(index) {
      this.dataGroup.forEach((element) => {
        element.check = false
      })
      // this.index = index
      this.checkItem = this.dataGroup[index]
      this.dataGroup[index].check = true
      if (this.dataGroup[index].userGroupMemberDtoList) {
        this.dataGroup[index].userGroupMemberDtoList.forEach((element) => {
          element.role = this.dataGroup[index].userRoleDto.userRoleName
        })
        this.dataSource = this.dataGroup[index].userGroupMemberDtoList
      } else {
        this.dataSource = []
      }
    },
    async handleAdd() {
      if (this.checkItem) {
        this.people = []
        await this.getTableList()
        this.visibleM = true
      } else {
        this.$message.error('请先添加用户组')
      }
    },

    handleEdit(record) {
      this.formModel = record
      this.visible = true
    },

    handleSearch() {
      // this.pagination.current = 1
      this.getTableList()
    },

    handleRefresh() {
      // this.pagination.current = 1
      this.visible = false
      this.getTableList()
    },

    handleReset() {
      this.search.userName = ''
      this.search.phone = ''
      this.search.mail = ''
      this.handleSearch()
    },

    //根据id删除数据
    async handleDelete(record) {
      const res = await detailMemberDelete(record.id)
      const { code, msg } = res
      if (code == '200') {
        this.leftData()
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    handleTableChange(pagination, filters, sorter) {
      // this.pagination = pagination
      if (sorter.order) {
        this.sorter = {
          orderKey: sorter.field,
          isAsc: sorter.order == 'ascend' ? true : false
        }
      } else {
        this.sorter = {}
      }
      this.getTableList()
    },
    // async getTableListAll() {
    //   let query = {
    //     pn: 1,
    //     pageSize: 99999999
    //   }
    //   this.loading = true
    //   let res = await queryUserApi(query)
    //   this.loading = false
    //   let { code, msg, data, extra } = res
    //   if (code == '200') {
    //     this.$nextTick(() => {
    //       this.dataPeople = data
    //     })

    //     console.log(this.dataPeople)
    //   } else {
    //     this.$message.error(msg)
    //   }
    // },
    async getTableList() {
      let query = {
        pn: 1,
        pageSize: 99999999
      }
      this.loading = true
      let res = await notAllot(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code == '200') {
        this.dataPeople = data.map((item) => {
          return {
            ...item
          }
        })
      } else {
        this.$message.error(msg)
      }
    },
    async getRoleList() {
      let query = {
        pn: 1,
        pageSize: 99999999,
        status: 1
      }
      this.loading = true
      let res = await queryRoleApi(query)
      this.loading = false
      let { code, msg, data } = res
      if (code == '200') {
        this.dataRole = data
      } else {
        this.$message.error(msg)
      }
    }
  },
  components: {
    Form
  }
}
</script>

<style lang="less" scoped>
.data-manage {
  padding: 16px;
  .leftSite {
    padding: 24px 24px 0 24px;
    background: #fff;
    height: 92vh;

    .buttonGroupCheck {
      width: 100%;
      height: 42px;
      border-radius: 6px;
      border: 1px solid #1890ff;
      font-size: 14px;
      color: #1890ff;
      text-align: center;
      font-weight: 400;
      box-shadow: 0px 2px 13px 0px rgba(51, 147, 235, 0.29);
      padding-top: 10px;
      margin-bottom: 30px;
    }
    .buttonGroup {
      width: 100%;
      height: 42px;
      border-radius: 6px;
      border: 1px solid rgba(151, 151, 151, 0.23);
      font-size: 14px;
      color: #000000;
      font-weight: 400;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      text-align: center;
      padding-top: 10px;
      margin-bottom: 30px;
    }
  }
  .search {
    padding: 20px 20px 0 20px;
    background: #fff;
    margin-bottom: 20px;
  }
  .table-wrap {
    background: #fff;
    padding: 0 20px 0 20px;
    height: 92vh;
  }
}
</style>
<style scoped>
.inputSearch /deep/ .ant-input {
  border-radius: 24px !important;
  border: 1px solid #979797;
}
</style>
